// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input, TextField
} from "@mui/material";

// App Imports


import {changeExchange} from "./exchangeSlice";
import {addExchange, editExchange} from "./ExchangeClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import Stack from "@mui/material/Stack";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import dayjs from "dayjs";


// Main Function
export default function ExchangeDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorExchangeId = useSelector((state) => state.exchangeSlc.value.id);
    const selectorExchangeDrawerState = useSelector((state) => state.exchangeSlc.value.exchangeDrawerState);
    const selectorExchangeDrawerMode = useSelector((state) => state.exchangeSlc.value.exchangeDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register,control, handleSubmit, reset} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Exchange data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorExchangeDrawerMode==="Add"){
            addExchange(data)
                .then(() => {
                    console.log("Exchange added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeExchange({
                    id: null, externalId: null, rateDate: null,
                    currencyFrom: null, currencyTo: null,
                    rate: null,
                    source: null,
                    effectiveDate: null, expiredOn: null,
                    subCount: null, countDate: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    exchangeGridRefresh: true, exchangeDrawerState: false, exchangeDrawerMode: null}))

            })}
        if(selectorExchangeDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addExchange(data)
                .then(() => {
                    console.log("Exchange cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeExchange({
                    id: null, externalId: null, rateDate: null,
                    currencyFrom: null, currencyTo: null,
                    rate: null,
                    source: null,
                    effectiveDate: null, expiredOn: null,
                    subCount: null, countDate: null, status: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    exchangeGridRefresh: true, exchangeDrawerState: false, exchangeDrawerMode: null}))

            })}
        if(selectorExchangeDrawerMode==="Edit"){
            console.log("This is the Exchange Id I am going to edit")
            console.log(selectorExchangeId)
            editExchange(selectorExchangeId, data)
                .then(() => {
                    console.log("Exchange edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeExchange({
                    exchangeGridRefresh: true, exchangeDrawerState: false, exchangeDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeExchangeDrawer() {
        dispatchData(changeExchange({exchangeDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()
            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);

// *********************** END DROPDOWNS **************************

    const exchange = useSelector((state) => state.exchangeSlc.value);

    useEffect(() => {

        reset({
            ...exchange,
            rateDate: exchange.rateDate
                ? dayjs(exchange.rateDate)
                : null,

            effectiveDate: exchange.effectiveDate
                ? dayjs(exchange.effectiveDate)
                : null,

            expiredOn: exchange.expiredOn
                ? dayjs(exchange.expiredOn)
                : null,
        });


    }, [exchange, reset]);

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    // ****************** BEGIN FORM ****************************

    function exchangeForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeExchangeDrawer()}>Exchange Form</h2>
                    <h4>{selectorExchangeDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <Input
                        style={{ visibility: "hidden" }}
                        {...register('id', { required: true })}
                        id="id" name="id"  label="id" aria-describedby="id_entry"
                        defaultValue=        {Number(useSelector((state) => state.exchangeSlc.value.id))}
                    />
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('externalId', { required: true })}
                            id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                            defaultValue=        {useSelector((state) => state.exchangeSlc.value.externalId)}
                            sx={{ width: 200 }} />
                        {/*<TextField*/}
                        {/*    {...register('rateDate', { required: true })}*/}
                        {/*    id="rateDate"   name="rateDate"  label="Rate Date" aria-describedby="rateDate_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.exchangeSlc.value.rateDate)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        <FormDatePicker
                            name="rateDate"
                            label="Rate Date"
                            control={control}
                            width={230}
                            variant = "outlined"
                       //     defaultValue=        {useSelector((state) => state.exchangeSlc.value.rateDate)}
                        />
                        {/*<TextField*/}
                        {/*    {...register('service', { required: true })}*/}
                        {/*    id="service"   name="service"  label="Service" aria-describedby="service_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.exchangeSlc.value.service)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        {/*<TextField*/}
                        {/*    {...register('source', { required: true })}*/}
                        {/*    id="source"   name="source"  label="Source" aria-describedby="source_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.exchangeSlc.value.source)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('currencyFrom', { required: true })}
                            id="currencyFrom"   name="currencyFrom"  label="Currency From" aria-describedby="currencyFrom_entry"
                            defaultValue=        {useSelector((state) => state.exchangeSlc.value.currencyFrom)}
                            sx={{ width: 200 }} />
                        <TextField
                            {...register('currencyTo', { required: true })}
                            id="currencyTo"   name="currencyTo"  label="Currency To" aria-describedby="currencyTo_entry"
                            defaultValue=        {useSelector((state) => state.exchangeSlc.value.currencyTo)}
                            sx={{ width: 200 }} />
                        <TextField
                            {...register('rate', { required: true })}
                            id="rate"   name="rate"  label="Rate" aria-describedby="rate_entry"
                            defaultValue=        {useSelector((state) => state.exchangeSlc.value.rate)}
                            sx={{ width: 200 }} />
                        <TextField
                            {...register('source', { required: true })}
                            id="source"   name="source"  label="Source" aria-describedby="source_entry"
                            defaultValue=        {useSelector((state) => state.exchangeSlc.value.source)}
                            sx={{ width: 200 }} />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('effectiveDate', { required: true })}*/}
                        {/*    id="effectiveDate"   name="effectiveDate"  label="Effective Date" aria-describedby="effectiveDate_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.exchangeSlc.value.effectiveDate)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        {/*<TextField*/}
                        {/*    {...register('expiredOn', { required: false })}*/}
                        {/*    id="expiredOn"   name="expiredOn"  label="Expired On" aria-describedby="expiredOn_entry"*/}
                        {/*    defaultValue=        {useSelector((state) => state.exchangeSlc.value.expiredOn)}*/}
                        {/*    sx={{ width: 200 }} />*/}
                        <FormDatePicker
                            name="effectiveDate"
                            label="Effective Date"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        <FormDatePicker
                            name="expiredOn"
                            label="Expired On"
                            control={control}
                            width={230}
                            variant = "outlined"
                        />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.exchangeSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.exchangeSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.exchangeSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.exchangeSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeExchangeDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorExchangeDrawerState}
                onClose={closeExchangeDrawer}
            >
                {exchangeForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
